import { useContext } from 'react'

import { NavigationV3Context } from 'components/NavigationV3/NavigationV3Provider'

export const useNavigationV3Context = () => useContext(NavigationV3Context)
